<template>
  <div v-if="company">
    <SubHeader title="Emails" />

    <b-row class="my-1">
      <b-col md="3"><label for="selectedSystem">Custom Email</label></b-col>
      <b-col md="9">
       <b-button
          class="my-1 margin-right"
          variant="primary"
          type="button"
          @click="newEmail">
          <font-awesome-icon icon="envelope" />&nbsp;Create
        </b-button>
      </b-col>
    </b-row>

    <SubHeader title="Campaign Documents"/>

    <b-table
      v-if="campaignDocuments && campaignDocuments.length > 0"
      :items="campaignDocuments"
      :fields="campaignFields"
      class="table"
      :responsive="true"
    >
      <template v-slot:cell(fileName)="data">
        {{ data.item.fileName }}
      </template>

      <template v-slot:cell(date)="data">
        {{ getDate(data.item.createdDatetime) }}<br />
      </template>

      <template v-slot:cell(campaign)="data">
        {{ data.item.campaign.campaignName }}
      </template>

      <template v-slot:cell(id)="data">
        <b-button type="button" variant="light" size="sm" @click="download(data.item.id, 'CAMPAIGN')"><font-awesome-icon icon="download" /></b-button>
      </template>

    </b-table>

    <b-alert variant="info" v-if="campaignDocuments == null || campaignDocuments.length == 0" show><strong>No Campaign Documents</strong> have been uploaded for this Company.</b-alert>

    <SubHeader title="Tag Documents" />

    

    <b-table
      v-if="tagDocuments && tagDocuments.length > 0"
      :items="tagDocuments"
      :fields="tagFields"
      class="table"
      :responsive="true"
    >
      <template v-slot:cell(fileName)="data">
        {{ data.item.fileName }}
      </template>

      <template v-slot:cell(date)="data">
        {{ getDate(data.item.createdDatetime) }}<br />
      </template>

      <template v-slot:cell(marketingTag)="data">
        {{ data.item.marketingTag.marketingTagName }}
      </template>

      <template v-slot:cell(id)="data">
        <b-button type="button" variant="light" size="sm" @click="download(data.item.id, 'TAG')"><font-awesome-icon icon="download" /></b-button>
      </template>

    </b-table>

    <b-alert v-if="tagDocuments == null || tagDocuments.length == 0" variant="info" show><strong>No Tag Documents</strong> have been uploaded for this Company.</b-alert>

    <SubHeader title="Documents" />

    <b-table
      v-if="documents && documents.length > 0"
      :items="documents"
      :fields="fields"
      class="table"
      :responsive="true"
    >
      <template v-slot:cell(fileName)="data">
        {{ data.item.fileName }}
      </template>

      <template v-slot:cell(date)="data">
        {{ getDate(data.item.createdDatetime) }}<br />11
        {{ data.item.createdUser.fullName }}
      </template>

      <template v-slot:cell(id)="data">
        <b-button type="button" variant="light" size="sm" @click="download(data.item.id, 'DOC')"><font-awesome-icon icon="download" /></b-button>&nbsp;
        <b-button type="button" variant="warning" size="sm" @click="email(data.item.id, false)"><font-awesome-icon icon="envelope" />&nbsp;Email Client</b-button>&nbsp;
        <b-button type="button" variant="primary" size="sm" @click="email(data.item.id, true)"><font-awesome-icon icon="envelope" />&nbsp;Email Director</b-button>
      </template>

    </b-table>

    <b-alert variant="info" v-if="documents.length == 0" show><strong>No Documents</strong> have been uploaded for this Company.</b-alert>

    <b-button
      class="my-1 margin-right"
      variant="primary"
      type="button"
      @click="addDocument">
      <font-awesome-icon icon="plus" />&nbsp;Add Document
    </b-button>

    <CompanyAddDocumentModal ref="companyAddDocumentModal" :company-id="$props.company.id" />
    <CompanyEmailModal ref="companyEmailModal" :company-id="$props.company.id" />
    <CompanyEmailDocumentModal ref="companyEmailDocumentModal" :company-id="$props.company.id" :document-id="emailDocumentId" :is-director="isDirector" />

  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import CompanyAddDocumentModal from "@/components/company/documents/CompanyAddDocumentModal.vue";
import CompanyEmailModal from "@/components/company/documents/CompanyEmailModal.vue";
import CompanyEmailDocumentModal from "@/components/company/documents/CompanyEmailDocumentModal.vue";
import { format } from 'date-fns'

export default {
  components: { SubHeader, CompanyAddDocumentModal, CompanyEmailModal, CompanyEmailDocumentModal },
  props: {
    company: Object,
  },
  watch: {
    company: function() {
      this.loadDocuments();
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (evt, modalId) => {
      if (modalId == 'companyAddDocumentModal') {
        this.loadDocuments();
      }
    });
  },
  methods: {
    loadDocuments() {
      this.$http.get('companydocument/company/' + this.$props.company.id).then((response) => {
        this.documents = response.data;
      });
      this.$http.get('companydocument/company/' + this.$props.company.id + '/campaign').then((response) => {
        this.campaignDocuments = response.data;
      });
      this.$http.get('companydocument/company/' + this.$props.company.id + '/tag').then((response) => {
        this.tagDocuments = response.data;
      });
    },
    newEmail() {
      this.$refs.companyEmailModal.showModal();
    },
    addDocument() {
      this.$refs.companyAddDocumentModal.showModal();
    },
    getDate(date) {
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
    download(id, type) {

      var docUrl = 'companydocument/' + id; // default for 'DOC' documents

      if (type == 'CAMPAIGN') {
        docUrl = 'companydocument/campaign/' + id;
      } else if (type == 'TAG') {
        docUrl = 'companydocument/marketingTag/' + id;
      }

      this.$http.get(docUrl, { responseType: 'blob' }).then((response) =>{
        var blob = new Blob([response.data], { type: 'application/' + response.headers['content-type'] });
        var blobElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob);
        blobElement.href = href
        blobElement.download = response.headers.filename;
        document.body.appendChild(blobElement)
        blobElement.click()
        document.body.removeChild(blobElement)
        window.URL.revokeObjectURL(href);
      });
    },
    email(id, isDirector) {
      if (isDirector) {
        this.$http.post('companydocument/email', { documentId: id, vendorId: 0, emailType: 0, toClient: false }).then((response) => {
          if (response.status == 200) {
            alert("Email sent to Director")
          }
        });
      }
      else {
        this.emailDocumentId = id;
        this.isDirector = isDirector;
        this.$refs.companyEmailDocumentModal.showModal();
      }
      
    }
  },
  data() {
    return {
      documents: [],
      campaignDocuments: [],
      tagDocuments: [],
      emailDocumentId: null,
      isDirector: null,
      fields: [
        { key: "fileName", label: "Name", sortable: false },
        { key: "date", label: "Date", sortable: false },
        { key: "id", label: "", sortable: false}
      ],
      campaignFields: [
        { key: "fileName", label: "Name", sortable: false },
        { key: "date", label: "Date", sortable: false },
        { key: "campaign", label: "Campaign", sortable: false },
        { key: "id", label: "", sortable: false}
      ],
      tagFields: [
        { key: "fileName", label: "Name", sortable: false },
        { key: "date", label: "Date", sortable: false },
        { key: "marketingTag", label: "Data Tag", sortable: false },
        { key: "id", label: "", sortable: false}
      ]
    };
  },
};
</script>
